import React from "react";
import styled from "styled-components";
import Item from "../../Course/components/Item";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { Title, Text } from "../../../theme/index";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: ${props => props.padding};
  align-items: center;
  @media (max-width: 1100px) {
    width: 100%;
    margin: 1em auto;
  }
`;

const Grid = styled.div`
  width: 75%;
  display: grid;
  grid-gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(275px, 1fr));
  grid-auto-rows: 210px;
  margin: 2em auto;
  @media (max-width: 1100px) {
    width: 100%;
    margin: 1em auto;
  }
`;

const Div = styled.div`
  border: 1px solid #ffaf77;
  width: 30%;
  background-color: #ffaf77;
  margin: 0 auto;
`;

function MandatoryCourses({ data: { error, courses }, requiredTime }) {
  if (error) return <h1>Error fetching courses!</h1>;
  if (courses && courses.length >= 1) {
    return (
      <Wrapper>
        <Title professionsub>Required courses</Title>
        <Div />
        <Text protitle>{requiredTime}</Text>
        <Grid>
          {courses &&
            courses.map((key, index) => {
              return (
                <Item
                  key={index}
                  name={key.name}
                  link={key.id && key.id}
                  img={
                    key.courseCard &&
                    `https://media.graphcms.com/${key.courseCard.handle}`
                  }
                />
              );
            })}
        </Grid>
      </Wrapper>
    );
  } else {
    return null;
  }
}

export const mandatory = gql`
  query($state: String, $profession: String) {
    courses(
      where: {
        professionPagesMandatory_some: {
          state: $state
          profession: $profession
        }
      }
    ) {
      id
      courseCard {
        handle
      }
    }
  }
`;

export default graphql(mandatory, {
  props: ({ data }) => ({
    data
  }),
  options(props) {
    let state = window.location.href.split("/")[4];
    state = state.replace(/-/g, " ");
    let profession = window.location.href.split("/")[3];
    profession = profession.replace(/-/g, " ");
    return {
      variables: {
        profession: profession,
        state: state
      }
    };
  }
})(MandatoryCourses);



// WEBPACK FOOTER //
// ./src/components/screens/Profession/components/MandatoryCourses.jsx